import React, { Fragment } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import ProductTeaserListItem from '../ProductTeaserListItem';
import styles from './styles';

function ProductTeaserList(props) {
  const { products, titleHtml } = props;

  if (!products || !products.length) {
    return null;
  }

  return (
    <Fragment>
      <div className="ProductTeaserList">
        {titleHtml && (
          <div
            className="ProductTeaserList__heading"
            dangerouslySetInnerHTML={{ __html: titleHtml }}
          />
        )}
        {products.map((product, index) => (
          <ProductTeaserListItem
            key={product.url}
            num={index + 1}
            total={products.length}
            image={product.image}
            {...product}
          />
        ))}
      </div>

      <style jsx>{styles}</style>
    </Fragment>
  );
}

ProductTeaserList.propTypes = {
  products: arrayOf(
    shape({
      url: string.isRequired
    })
  ),
  titleHtml: string
};

ProductTeaserList.defaultProps = {
  products: undefined,
  titleHtml: undefined
};

export default ProductTeaserList;
